import { Component, inject, OnInit } from '@angular/core';
import { AppMenuitem } from '@app/layout/components/app.menuitem';
import { ClientConfigService } from '@app/layout/service/client-config/client-config.service';
import { getUserMenu } from '@core/functions/menu';
import { Account } from '@core/models/auth.model';
import { MenuItem } from '@core/models/menu.model';
import { SessionService } from '@core/services/session/session.service';

@Component({
  selector: '[client-menu]',
  imports: [AppMenuitem],
  templateUrl: './client-menu.component.html',
})
export class ClientMenuComponent implements OnInit {
  public clientConfigService = inject(ClientConfigService);
  public clientConfig = this.clientConfigService.getConfig()!;
  private readonly sessionService = inject(SessionService);

  account!: Account;

  ngOnInit(): void {
    this.account = this.sessionService.getActiveAccount()!;
    this.menuUser = getUserMenu(this.account, this.model);
  }

  menuUser: MenuItem[] = [];

  // TODO: Definir la estructura del menú para el cliente con permisos y rutas especificas

  model: MenuItem[] = [
    {
      label: 'Dashboards',
      icon: 'pi pi-home',
      items: [
        {
          label: 'Inicio',
          icon: 'pi pi-fw pi-home',
          routerLink: [`/${this.clientConfig.slug}/home`],
        },
        {
          label: 'Envíos',
          icon: 'pi pi-fw pi-send',
          routerLink: [`/${this.clientConfig.slug}/shipments`],
        },
      ],
    },
    { separator: true },
    {
      label: 'Envíos',
      icon: 'pi pi-fw pi-send',
      items: [
        {
          label: 'Entradas',
          icon: 'pi pi-fw pi-directions-alt',
          routerLink: [`/${this.clientConfig.slug}/shipments/entries`],
        },
        {
          label: 'Salidas',
          icon: 'pi pi-fw pi-directions-alt',
          routerLink: [`/${this.clientConfig.slug}/shipments/departures`],
        },
        {
          label: 'Incidencias',
          icon: 'pi pi-fw pi-exclamation-triangle',
          routerLink: [`/${this.clientConfig.slug}/shipments/incidents`],
        },
        {
          label: 'Seguimientos',
          icon: 'pi pi-fw pi-search',
          routerLink: [`/${this.clientConfig.slug}/shipments/tracking`],
        },
        {
          label: 'Envíos de grupo',
          icon: 'pi pi-fw pi-plus',
          items: [
            {
              label: 'VIP',
              icon: 'pi pi-fw pi-crown',
              routerLink: [`/${this.clientConfig.slug}/shipments/vip`],
            },
            {
              label: 'Económico',
              icon: 'pi pi-fw pi-dollar',
              routerLink: [`/${this.clientConfig.slug}/shipments/economic`],
            },
          ],
        },
      ],
    },
    { separator: true },
    {
      label: 'Herramientas',
      icon: 'pi pi-fw pi-plus',
      items: [
        {
          label: 'QR',
          icon: 'pi pi-fw pi-qrcode',
          routerLink: [`/${this.clientConfig.slug}/tools/qr`],
        },
        {
          label: 'Widgets',
          icon: 'pi pi-fw pi-box',
          routerLink: [`/${this.clientConfig.slug}/tools/widgets`],
        },
      ],
    },
    { separator: true },
    {
      label: 'Usuarios',
      icon: 'pi pi-fw pi-users',
      items: [
        {
          label: 'Usuarios',
          icon: 'pi pi-fw pi-users',
          routerLink: [`/${this.clientConfig.slug}/users`],
        },
        {
          label: 'Roles',
          icon: 'pi pi-fw pi-key',
          routerLink: [`/${this.clientConfig.slug}/roles`],
        },
        {
          label: 'Usuarios web',
          icon: 'pi pi-fw pi-link',
          routerLink: [`/${this.clientConfig.slug}/users-web`],
        },
      ],
    },
    { separator: true },
    {
      label: 'Ajustes',
      icon: 'pi pi-fw pi-cog',
      items: [
        {
          label: 'Sitio web',
          icon: 'pi pi-fw pi-cog',
          routerLink: [`/${this.clientConfig.slug}/config/website`],
        },
        {
          label: 'Apariencia',
          icon: 'pi pi-fw pi-eye',
          items: [
            {
              label: 'Colores',
              icon: 'pi pi-fw pi-palette',
              routerLink: [`/${this.clientConfig.slug}/config/appearance/colors`],
            },
            {
              label: 'Tipografía',
              icon: 'pi pi-fw pi-info',
              routerLink: [`/${this.clientConfig.slug}/config/appearance/typography`],
              disabled: true,
            },
            {
              label: 'Archivos',
              icon: 'pi pi-fw pi-file',
              routerLink: [`/${this.clientConfig.slug}/config/appearance/files`],
            },
          ],
        },
        {
          label: 'Integraciones',
          icon: 'pi pi-fw pi-eject',
          permission: 'view_integrations',
          items: [
            {
              label: 'Empresas de transporte',
              icon: 'pi pi-fw pi-truck',
              routerLink: [`/${this.clientConfig.slug}/config/integrations/shipping-companies`],
            },
            {
              label: 'Métodos de pago',
              icon: 'pi pi-fw pi-wallet',
              routerLink: [`/${this.clientConfig.slug}/config/integrations/payment-methods`],
            },
          ],
        },
        {
          label: 'Configuración avanzada',
          icon: 'pi pi-fw pi-cog',
        },
      ],
    },
  ];
}
